import { RuntimeConfigService } from '@ahoy/aquarium/dist/core/services/RuntimeConfigService';

import { BaseService } from './base-service';

export class ConfigService extends RuntimeConfigService {
  static serviceName = 'configService';
}

BaseService.define.call(ConfigService);